module.exports = __webpack_public_path__ + "static/s5-object2-66c0854dec2a8cd5fe48a1da0efd2f06.png";